import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('cautionStatusBadge');

    return {
        CAUTION: t('caution')
    };
};

export default useTranslation;
